import { Link } from "react-router-dom"

const Missing = () => {
    return (
        <article style={{ padding: "100px" }}>
            <h1>Oops!</h1>
            <p>Page inexistant</p>
            <div className="flexGrow">
                <Link to="/">aller a la page acceuil</Link>
            </div>
        </article>
    )
}

export default Missing
